"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Auth = exports.ERROR_LOCK_HIDDEN = void 0;
var auth0_lock_1 = __importDefault(require("auth0-lock"));
var jwt_decode_1 = __importDefault(require("jwt-decode"));
exports.ERROR_LOCK_HIDDEN = "ERROR/LOCK_HIDDEN";
var LOCAL_STORAGE_KEY = "platfi-ui-app/SESSION";
var Auth = /** @class */ (function () {
    function Auth(baseUrl, defaultPath) {
        if (defaultPath === void 0) { defaultPath = "test"; }
        var _this = this;
        this.url = "";
        this.defaultPath = "";
        this.login = function () {
            _this.lock.show();
        };
        this.onAuthentication = function () {
            return new Promise(function (resolve, reject) {
                _this.lock.on("unrecoverable_error", function (error) {
                    _this.lock.hide();
                    reject(error);
                });
                _this.lock.on("authorization_error", function (error) { return reject(error); });
                _this.lock.on("authenticated", function (_a) {
                    var accessToken = _a.accessToken;
                    return resolve(_this.processToken(accessToken));
                });
            });
        };
        this.renewToken = function () {
            return new Promise(function (resolve, reject) {
                return _this.lock.checkSession({}, function (error, response) {
                    return error ? reject(error) : resolve(_this.processToken(response.accessToken));
                });
            });
        };
        this.processToken = function (token) {
            var decoded = (0, jwt_decode_1["default"])(token);
            return {
                accessToken: token,
                expiresAt: decoded.exp,
                tokenPayload: decoded
            };
        };
        this.onLoginSuccess = function (token) {
            var tokenProcessed = _this.processToken(token);
            window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(tokenProcessed));
            window.location.href = "".concat(_this.url, "/").concat(_this.defaultPath);
        };
        this.checkSession = function () {
            _this.lock.checkSession({}, function (error, result) {
                if (error) {
                    console.log(error);
                    return;
                }
                _this.onLoginSuccess(result.accessToken);
            });
        };
        /**
         *
         * @param returnTo defaults to the url of the constructor
         */
        this.logout = function (_a) {
            var _b = _a.returnTo, returnTo = _b === void 0 ? _this.url : _b;
            _this.lock.logout({
                returnTo: returnTo || _this.url,
                clientID: window._env_.AUTH0_CLIENT_ID
            });
            window.localStorage.removeItem(LOCAL_STORAGE_KEY);
        };
        this.url = baseUrl;
        this.defaultPath = defaultPath;
        this.lock = new auth0_lock_1["default"](window._env_.AUTH0_CLIENT_ID, window._env_.AUTH0_DOMAIN, {
            autoclose: true,
            auth: {
                audience: window._env_.AUTH0_AUDIENCE,
                redirectUrl: "".concat(this.url, "/callback"),
                responseType: "token id_token"
            }
        });
    }
    return Auth;
}());
exports.Auth = Auth;
